import SelfiesTip from './SelfiesTip';

export default SelfiesTip;
